<template>
  <div class="container">
    <h1>拉卡拉微信支付</h1>
    
    <div class="note">
      <h3>使用说明</h3>
      <p>请输入以下信息以发起微信支付：</p>
      <ul>
        <li><strong>用户ID</strong>：微信用户ID</li>
        <li><strong>商户订单号</strong>：商户系统中的订单号（需唯一）</li>
        <li><strong>交易金额</strong>：单位为分</li>
      </ul>
    </div>
    
    <form @submit.prevent="submitForm">
      <div class="form-group">
        <label for="userId">微信用户ID:</label>
        <input type="text" id="userId" v-model="form.userId" required>
      </div>
      
      <div class="form-group">
        <label for="outTradeNo">商户订单号:</label>
        <input type="text" id="outTradeNo" v-model="form.outTradeNo" required>
      </div>
      
      <div class="form-group">
        <label for="totalAmount">交易金额(分):</label>
        <input type="number" id="totalAmount" v-model.number="form.totalAmount" min="1" required>
      </div>
      
      <button type="submit" id="submitBtn" :disabled="loading">
        {{ loading ? '处理中...' : '发起微信支付' }}
      </button>
    </form>
    
    <div class="loading" v-if="loading">
      <div class="spinner"></div>
      <p>正在处理支付请求...</p>
    </div>
    
    <div class="result" :class="resultClass" v-if="result.message">
      <strong>{{ result.type }}:</strong> {{ result.message }}
      <div v-if="result.details">
        <p><strong>详细信息:</strong> {{ result.details }}</p>
      </div>
      <div v-if="result.errorCode">
        <p><strong>错误代码:</strong> {{ result.errorCode }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'LakalaWechatPayment',
  data() {
    return {
      form: {
        userId: '',
        outTradeNo: '',
        totalAmount: 1
      },
      loading: false,
      result: {
        type: '',
        message: '',
        details: '',
        errorCode: ''
      }
    };
  },
  computed: {
    resultClass() {
      return this.result.type === 'success' ? 'success' : 'error';
    }
  },
  mounted() {
    // 生成随机订单号
    this.form.outTradeNo = 'ORDER_' + Date.now() + '_' + Math.floor(Math.random() * 1000);
  },
  methods: {
    async submitForm() {
      this.loading = true;
      this.result = { type: '', message: '', details: '', errorCode: '' };
      
      try {
        const response = await api.post('/lakala/wechat/preorder', {
          userId: this.form.userId,
          outTradeNo: this.form.outTradeNo,
          totalAmount: this.form.totalAmount.toString()
        });
        
        const data = response.data;
        
        if (data.success) {
          this.result = {
            type: 'success',
            message: data.message,
            details: data.data ? JSON.stringify(data.data) : ''
          };
        } else {
          this.result = {
            type: 'error',
            message: data.message,
            details: data.details,
            errorCode: data.errorCode
          };
        }
      } catch (error) {
        console.error('请求失败:', error);
        this.result = {
          type: 'error',
          message: '无法连接到服务器，请检查网络连接或稍后重试。',
          details: '错误详情: ' + error.message
        };
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}
h1 {
  color: #333;
  text-align: center;
  margin-bottom: 30px;
}
.form-group {
  margin-bottom: 20px;
}
label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
}
input {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 16px;
}
button {
  background-color: #07c160;
  color: white;
  padding: 14px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  width: 100%;
  transition: background-color 0.3s;
}
button:hover:not(:disabled) {
  background-color: #06ad56;
}
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
.result {
  margin-top: 20px;
  padding: 15px;
  border-radius: 4px;
}
.success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}
.error {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}
.loading {
  text-align: center;
  padding: 20px;
}
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #07c160;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 0 auto 10px;
}
@keyframes spin {
  to { transform: rotate(360deg); }
}
.note {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 20px;
  color: #856404;
}
.note ul {
  margin: 10px 0;
  padding-left: 20px;
}
.note li {
  margin-bottom: 5px;
}
</style>